import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SugerenciaSegmento } from "../../viajes/edit/items/selectores/sugerenciasegmento";

export interface ReporteCargaAdministradores {
    idCamion: number;
    idSegmento: number;
}

export interface Props extends kea.ModalProps<ReporteCargaAdministradores, boolean, undefined> {
}

/**
 * Valida un ReporteManifiesto
 */
export function validar(x: ReporteCargaAdministradores) {
    const rules: validation.Rules<ReporteCargaAdministradores> = {
        idCamion: validation.required,
        idSegmento: validation.required
    };
    return validation.getErrors(rules, x);
}

const ImprimirButton = kea.defaultProps(kea.Button, { children: "Imprimir", iconClass: fa("print") });

/**
* Modal de edición para un ReporteManifiesto
*/
export class ReporteCargaAdministradoresEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Camion = getField(selectores.Camion);
        const Segmento = getField(SugerenciaSegmento);

        return (
            <kea.Modal
                buttons={[<ImprimirButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Imprimir reporte de carga de administradores"
            >

                {kea.autogrid(6, [
                    <Camion field="idCamion" label="Camión" />,
                    value.idCamion != null && <Segmento field="idSegmento" filtro={{ idCamion: value.idCamion }} label="Segmento" />
                ])}
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/pantalla/reporteCargaAdministrador.tsx